<template>
    <div id="app">
        <q-window-resize-observable @resize="onResize" />
        <transition name="page" mode="out-in">
            <component v-if="layout" :is="layout"></component>
        </transition>
    </div>
</template>

<script>
    import {
        QWindowResizeObservable
    } from 'quasar-framework'

    // Load layout components dynamically.
    const requireContext = require.context('../layouts', false, /.*\.vue$/)

    const layouts = requireContext.keys()
        .map(file =>
            [file.replace(/(^.\/)|(\.vue$)/g, ''), requireContext(file)]
        )
        .reduce((components, [name, component]) => {
            components[name] = component
            return components
        }, {})

    export default {
        el: '#app',

        data: () => ({
            layout: null,
            defaultLayout: 'default'
        }),

        metaInfo() {
            const {appName} = window.config

            return {
                title: appName,
                loading: true,
                titleTemplate: appName
                //titleTemplate: `%s · ${appName}`
            }
        },

        components: {
            QWindowResizeObservable
        },

        methods: {
            /**
             * Set the application layout.
             *
             * @param {String} layout
             */
            setLayout(layout) {
                if (!layout || !layouts[layout]) {
                    layout = this.defaultLayout
                }

                this.layout = layouts[layout]
            },

            onResize (size) {
                this.$breakpoints.windowSize = size
            }
        },

        mounted() {
            this.$store.dispatch('userMenu/saveMenu')
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/App.vue